export const ErrorCode = {
  ValidationFailed: "VALIDATION_FAILED",
  NotFound: "NOT_FOUND",
  Unauthorized: "UNAUTHORIZED",
  Forbidden: "FORBIDDEN",
  Conflict: "CONFLICT",
  NotImplemented: "NOT_IMPLEMENTED",
  Internal: "INTERNAL",

  UserNotFound: "USER_NOT_FOUND",
  UserAlreadyExists: "USER_ALREADY_EXISTS",
  AdminRoleNotAssignable: "ADMIN_ROLE_NOT_ASSIGNABLE",

  OnboardingNotConfigured: "ONBOARDING_NOT_CONFIGURED",

  OrganizationNotFound: "ORGANIZATION_NOT_FOUND",
  OrganizationSlugTaken: "ORGANIZATION_SLUG_TAKEN",

  TempAccessNotRequestable: "TEMP_ACCESS_NOT_REQUESTABLE",
  TempAccessGrantNotFound: "TEMP_ACCESS_GRANT_NOT_FOUND",
  TempAccessAlreadyHasAccess: "TEMP_ACCESS_ALREADY_HAS_ACCESS",
  TempAccessDuplicateRequest: "TEMP_ACCESS_DUPLICATE_REQUEST",
} as const;

export type ErrorCode = (typeof ErrorCode)[keyof typeof ErrorCode];
